import { FC } from "react";
import useNavigateWithToast from "../../../utils/useNavigateWithToast/useNavigateWithToast";
import { useParams } from "react-router-dom";
import { useQueryClient } from "react-query";
import { useGetBase } from "../../../services/base/base.service";
import { useFetchErrorToast } from "../../../utils/useFetchErrorToasts/useFetchErrorToast";
import Header from "../Header";
import EditBaseForm from "./EditBaseForm";
import Loading from "../../../components/Loading/Loading";

const EditBase: FC = () => {
  const navigateWithToast = useNavigateWithToast();
  const queryClient = useQueryClient();
  const {
    baseId: baseIdParam
  } = useParams<{ baseId: string }>();
  const baseId = +(baseIdParam ?? '-1'); //TODO: Check if -1 or empty string

  const {
    data: getBaseResponse,
    isError: getBaseIsError,
    error: getBaseError
  } = useGetBase({ baseId });
  const base = getBaseResponse?.data;

  useFetchErrorToast([
    {
      label: 'Error fetching base data',
      id: 'baseDataFetchError',
      isError: getBaseIsError,
      error: getBaseError
    }
  ]);

  const navigateToTableWithSuccessToast = () => {
    queryClient.invalidateQueries(['getBase', baseId]);
    navigateWithToast(
        `/tables/bases`,
        {
          label: 'Base has been updated successfully',
          id: 'baseUpdateSuccess'
        }
    );
  }

  return (
      <>
        <Header
            breadcrumb={{ label: 'Back to Base Table', to: '/tables/bases' }}
            title={`View Base ${base?.baseNo ?? ''} - ${base?.longDescription ?? ''}`}
        />
        {!!base
            ? <EditBaseForm
                base={base}
                onSuccess={navigateToTableWithSuccessToast}
            />
            : <Loading size={12}/>
        }
      </>
  )
}

export default EditBase;